import { Switch, Route, Redirect } from 'react-router-dom';
import Calendar from './Calendar';
import Carousel from './Carousel';


const Components = () => {
    return <div className="container xxl py-3">

        <Switch>
            <Route exact path='/components/carousel' component={Carousel} />
            <Route exact path='/components/calendar' component={Calendar} />
            <Redirect from='/components' to='/components/carousel' />
        </Switch>

    </div>
}

export default Components